import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import moment from 'moment-timezone';
import { WsSalesSolutionItem } from "../core";
import { getSalesSolution } from "./Sales/Solution/helpers";
import { salesOfferingsTransformData } from "../core/sales-process";
import { Loading } from "./Shared";
import { WsSalesRiskRadar } from "./Sales/Solution/SalesRiskRadar";
import { WsSalesTimeline2 } from "./Sales/Solution/SalesTimeline2";
import { WsSalesSolutionPeople } from "./Sales/Solution/SalesPeople";




const WsScreenshotTimeline = () => {

  const { solutionId, page }: { solutionId?: string, page: string } = useParams();

  const [ salesProcess, setSalesProcess ] = useState<any | undefined>(undefined);

  const [ items, setItems ] = useState<WsSalesSolutionItem[]>([]);


  useEffect(() => {

    setTimeout(async () => {

      if (solutionId) {

        const salesSolution = await getSalesSolution(solutionId, true);

        if (salesSolution) {

          // console.log(salesSolution);
          setSalesProcess(salesSolution);

          // offering items
          const offeringItems = salesOfferingsTransformData(salesSolution.state, {});
          setItems(offeringItems);

        }
      }

    }, 100);

  }, [ solutionId ]);


  if (salesProcess && items && items.length > 0) {

    if (page === 'risk') {

      return(
        <div className="ws-sales-screenshot-page">
          <WsSalesRiskRadar
            salesProcess={salesProcess}
            title="Risk Assessment"
          />
        </div>
      );

    } else if (page === 'people') {

      return(
        <div className="ws-sales-screenshot-page">
          <WsSalesSolutionPeople
            startDate={moment(`${salesProcess.expectedStart}-01T00:00:00Z`).tz('UTC').toDate()}
            items={items}
          />
        </div>
      );

    } else {

      return (
        <div className="ws-sales-screenshot-page">
          <div className="ws-sales-screenshot-timeline">
            <WsSalesTimeline2
              startDate={moment(`${salesProcess.expectedStart}-01T00:00:00Z`).tz('UTC').toDate()}
              items={items}
              screenshot={true}
              avanade={true}
            />
          </div>
        </div>
      );
    }

  } else {
    return (
      <Loading />
    );
  }
};




export {
  WsScreenshotTimeline
};
